import { BaseContainerModel } from '../base-container.model';
import { bl_opdg_element_by_brand_RowClass } from '../../dbschema';


export class InventoryOpdgElementByBrandContainerModel extends BaseContainerModel {
    bl_opdg_element_by_brand: bl_opdg_element_by_brand_RowClass = new bl_opdg_element_by_brand_RowClass();
  }